import { render } from "./Certs.vue?vue&type=template&id=f76d77f4"
import script from "./Certs.vue?vue&type=script&lang=js"
export * from "./Certs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__